module.exports = __webpack_public_path__ + "img/20190521113029微信截图_20190521113244.png.63c89c05.png";